import { render, staticRenderFns } from "./channelUser.vue?vue&type=template&id=72e8096e&scoped=true"
import script from "./channelUser.vue?vue&type=script&lang=js"
export * from "./channelUser.vue?vue&type=script&lang=js"
import style0 from "./channelUser.vue?vue&type=style&index=0&id=72e8096e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72e8096e",
  null
  
)

export default component.exports